import { PaymentMethodEnum } from "@/definitions/enums/payment-method"

export const QUERY_PARAM_KEYS = [
  "limit",
  "offset",
  "status",
  "policyNumber",
  "subPolicyHolder",
  "insuranceType",
  "groupType",
  "endorsement",
  "dueDate",
  "customerDocument",
  "customerFullName",
  "brokerDocument",
  "brokerName",
  "brokerEmail",
  "brokerId",
  "paymentDate",
  "paymentDateInit",
  "paymentDateEnd",
  "dueDateInit",
  "dueDateEnd",
  "createdAt",
  "createdAtInit",
  "createdAtEnd",
  "fileType",
  "reportType",
  "paymentMethod",
  "fullName",
  "document",
  "email",
  "name",
  "ownId",
  "skipCache",
  "lastLoginAt",
  "recordLine",
] as const

type QueryParamKey = (typeof QUERY_PARAM_KEYS)[number]

export type QueryParams<T> = Partial<{
  [K in QueryParamKey]: K extends "status"
    ? T | null
    : K extends "paymentMethod"
      ? PaymentMethodEnum | null
      : string | null
}>
